// extracted by mini-css-extract-plugin
export default {"footer":"_24h22","footerLeftSide":"yP6v-","likesCount":"TK4jj","commentsCountContainer":"VVqeI","commentsCount":"sJeNt","tooltip":"TXHGb"};